exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cell[data-v-0b93c0b5] {\n  height: 1rem;\n  padding: 0.6rem 0.5rem;\n}\n.cell .title img[data-v-0b93c0b5] {\n  height: 1rem;\n  width: auto;\n  margin-right: 0.5rem;\n}\n.cell .title span[data-v-0b93c0b5] {\n  height: 0.9rem;\n  margin-top: 0.05rem;\n  display: inline-block;\n}", ""]);

// exports
